import { CheckboxActiveIcon } from "app/components/Icons";
import CheckboxIcon from "app/components/Icons/CheckboxIcon";
import ArchiveModalWrapper from "app/containers/Features/components/ArchiveModalWrapper";
import { ticketGroupsActions } from "app/containers/Features/containers/Boards/containers/Tickets/redux/slice";
import { actions } from "app/redux/slice";
import { ArchiveType } from "app/types";
import clsx from "clsx";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import ColumnOptionsMenu from "./ColumnOptionsMenu";

interface Props {
  ticketId: string;
  ticketName: string;
  isSelected: boolean;
  onSelectTicket: () => void;
}

const ItemAction: React.FC<Props> = ({
  ticketId,
  isSelected,
  onSelectTicket,
  ticketName = "",
}) => {
  const { project } = useParams();
  const dispatch = useDispatch();
  const [showArchive, setShowArchive] = React.useState(false);
  const [showActions, setShowActions] = React.useState(false);

  const handleArchive = () => {
    dispatch(
      actions.doArchive({
        projectId: project || "",
        dataId: [ticketId || ""],
        dataType: ArchiveType.TICKET,
        callback() {},
      }),
    );
    // is use for remove ticket from local group
    dispatch(ticketGroupsActions.removeTicketLocally({ ticketIds: ticketId }));

    setShowArchive(false);
  };

  return (
    <div className="relative">
      {isSelected ? (
        <div
          className="flex flex-row items-center opacity-100 px-1.5 h-[30px]"
          onClick={(e) => {
            e.stopPropagation();
            onSelectTicket();
          }}
        >
          <CheckboxActiveIcon size={18} />
        </div>
      ) : (
        <div
          className={clsx(
            "flex flex-row items-center justify-between px-1.5 border border-gray-100 gap-1.5 group-hover:opacity-100 transition-opacity duration-200 rounded-md h-[30px] relative",
            showActions ? "opacity-100" : "opacity-0",
          )}
        >
          <ColumnOptionsMenu
            onArchive={() => {
              setShowArchive(true);
            }}
            onDuplicate={() => {
             dispatch(ticketGroupsActions.duplicateTicketLocally({ ticketIds: ticketId }));
            }}
            showActions={showActions}
            setShowActions={setShowActions}
          />
          <button
            className=" rounded"
            onClick={(e) => {
              e.stopPropagation();
              onSelectTicket();
            }}
          >
            <CheckboxIcon color="#79808A" size={16} />
          </button>
        </div>
      )}
      {showArchive && (
        <ArchiveModalWrapper
          onClose={() => setShowArchive(false)}
          content={`Are you sure that you want to archive <span class=" !font-medium">${ticketName}</span>?`}
          onSave={() => {
            handleArchive();
          }}
          title="Archive ticket"
          backButtonText="Revert"
        />
      )}
    </div>
  );
};

export default ItemAction;
